<template>
  <div>
    <b-table
      :items="records"
      :fields="fields"
      :busy="isLoaging"
      class="col-12 mt-2 table-views"
      show-empty
    >
      <template #empty>
        <div class="text-center my-2">
          <h3>No hay exámenes registrados</h3>
        </div>
      </template>
      <template #cell(worker)="row">
        {{ row.item?.employee?.name }}
      </template>
      <template #cell(diagnostic)="row">
        {{ row.item?.diagnostic?.diagnostic?.name }}
      </template>

      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <overlay-button></overlay-button>
        </div>
      </template>
      <template #cell(options)="row">
        <button
          class="button-table-employee"
          :id="`tooltip-button-ver-${row.item?.id}`"
          @click.prevent="findItem(row.item?.id)"
        >
          <img
            class="centerImg1 resaltar"
            :src="require('@/assets/images/icons/eye-line.svg')"
          />
        </button>

        <b-tooltip
          :target="`tooltip-button-ver-${row.item.id}`"
          placement="top"
          custom-class="custom-tooltip-ht"
        >
          Ver Detalle
        </b-tooltip>
      </template>
    </b-table>
  </div>
</template>

<script>
import Pagination from "laravel-vue-pagination";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import {
  getAllHealthCondition,
} from "@/services/health-tracker/saludCondition/service";
export default {
  components: {
    Pagination,
    OverlayButton,
  },
  data() {
    return {
      fields: [
        {
          label: "Trabajador",
          key: "worker",
        },
        {
          label: "Diagnostico",
          key: "diagnostic",
        },
        {
          label: "Nombre del médico",
          key: "doctor_name",
        },
        {
          label: "Fecha de registro",
          key: "created_at",
        },
        {
          label: "",
          key: "options",
        },
      ],
      isLoaging: false,
      records: [],
      id: this.$route.params.type
    };
  },
  watch: {
    $route() {
      const me = this;
      me.id = me.$route.params.type;
      me.loadHealthCondition();
    },
  },
  methods: {
    findItem(id) {
      const me = this;
      me.$router.push({
        name: "DetailExamenPage",
        params: { category: "salud-condition", type: me.$route.params.type, id: id },
      });
    },
    async loadHealthCondition() {
      const me = this;
      me.isLoaging = true;
      try {
        const result = await getAllHealthCondition(me.id);
        me.records = result?.data?.data;
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoaging = false;
      }
    },
  },
  mounted() {
    const me = this;
    me.loadHealthCondition();
  }
};
</script>

<style lang="css">
.custom-tooltip-ht .tooltip-inner {
  max-width: 200px !important;
  background-color: #263238 !important;
  font-size: 14px !important;
}
.text-file {
  color: #1719da80;
  font-size: 16px;
  cursor: pointer;
}
.list-diagnostic {
  list-style: disc !important;
  padding: 0 !important;
}
.list-diagnostic li {
  overflow: hidden;
  width: 250px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
